export var AuditAction;
(function (AuditAction) {
    AuditAction["CREATE"] = "CREATE";
    AuditAction["UPDATE"] = "UPDATE";
    AuditAction["DELETE"] = "DELETE";
    AuditAction["ACCESS_CHANGE"] = "ACCESS_CHANGE";
    AuditAction["EXPORT"] = "EXPORT";
    AuditAction["IMPORT"] = "IMPORT";
    AuditAction["SEND"] = "SEND";
    AuditAction["REFUND"] = "REFUND";
    AuditAction["IMPERSONATE"] = "IMPERSONATE";
    AuditAction["CONFIGURE"] = "CONFIGURE";
    AuditAction["EXECUTE"] = "EXECUTE";
})(AuditAction || (AuditAction = {}));
export var AuditSource;
(function (AuditSource) {
    AuditSource["DASHBOARD"] = "DASHBOARD";
    AuditSource["ADMIN"] = "ADMIN";
    AuditSource["BOOKING_ENGINE"] = "BOOKING_ENGINE";
    AuditSource["GUEST_APP"] = "GUEST_APP";
    AuditSource["API"] = "API";
    AuditSource["INTEGRATION"] = "INTEGRATION";
    AuditSource["BACKGROUND_JOB"] = "BACKGROUND_JOB";
})(AuditSource || (AuditSource = {}));
export var AuditOutcome;
(function (AuditOutcome) {
    AuditOutcome["SUCCESS"] = "SUCCESS";
    AuditOutcome["FAILURE"] = "FAILURE";
    AuditOutcome["PARTIAL"] = "PARTIAL";
})(AuditOutcome || (AuditOutcome = {}));
export var AuditActorType;
(function (AuditActorType) {
    AuditActorType["USER"] = "USER";
    AuditActorType["GUEST"] = "GUEST";
    AuditActorType["API_KEY"] = "API_KEY";
    AuditActorType["INTEGRATION"] = "INTEGRATION";
    AuditActorType["AUTOMATION"] = "AUTOMATION";
    AuditActorType["SYSTEM"] = "SYSTEM";
})(AuditActorType || (AuditActorType = {}));
export var ActionType;
(function (ActionType) {
    ActionType["CREATE"] = "CREATE";
    ActionType["UPDATE"] = "UPDATE";
    ActionType["DELETE"] = "DELETE";
})(ActionType || (ActionType = {}));
